import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Container from 'common/Container';
import {
  Hero,
  Synopsis,
  SocialProof,
  Journey,
  GuestProfile,
  PatrocinioCallout,
  ApplicationForm,
  InstitutionalFooter,
} from './components';

const LandingMediaKitBusiness = ({ themeMode = 'light' }) => {
  return (
    <Box>
      <Container sx={{ pb: 0 }}>
        <Hero themeMode={themeMode} />
      </Container>
      <Container
        sx={{
          mt: -8,
          position: 'relative',
          zIndex: 2,
        }}
      >
        <Synopsis />
      </Container>
      <Container>
        <SocialProof />
      </Container>
      <Container>
        <Journey />
      </Container>
      <Container>
        <GuestProfile />
      </Container>
      <Container>
        <PatrocinioCallout />
      </Container>
      <Container>
        <ApplicationForm />
      </Container>
      <Container>
        <InstitutionalFooter />
      </Container>
    </Box>
  );
};

LandingMediaKitBusiness.propTypes = {
  themeMode: PropTypes.string,
};

export default LandingMediaKitBusiness;

